import {PayloadAction} from '@reduxjs/toolkit';
import {Badge, Button} from 'antd';
import React, {FC} from 'react';

import {TABLE_COLUMN_FILTER_CLEAR_EVENT_KEY} from 'components/@common/widgets/custom-table/table-column-filter/table-column-filter-constants';
import {TTableColumnFilterExpressionDto} from 'components/@common/widgets/custom-table/table-column-filter/table-column-filter-types';
import {TTableColumnFilters} from 'components/@common/widgets/custom-table/table-column-filter/use-table-column-filter';
import {useAppDispatch, useAppSelector} from 'store/config/hooks';
import {TAppState} from 'store/config/types';

import './clear-table-column-filters-button.less';

interface IClearTableColumnFiltersButtonProps {
  setTableColumnFilters: (payload: {
    filters: TTableColumnFilters | undefined;
    noFetch?: boolean;
  }) => PayloadAction<{
    filters: TTableColumnFilters | undefined;
    noFetch?: boolean;
  }>;
  selectTableFiltersDataAdaptedForRequest: (state: TAppState) => (TTableColumnFilterExpressionDto | undefined);

}

export const ClearTableColumnFiltersButton: FC<IClearTableColumnFiltersButtonProps> = ({
    setTableColumnFilters,
    selectTableFiltersDataAdaptedForRequest,
}: IClearTableColumnFiltersButtonProps) => {
    const dispatch = useAppDispatch();
    const tableColumnFilters = useAppSelector(selectTableFiltersDataAdaptedForRequest);

    const showClearButton = !!(tableColumnFilters?.groups.length || tableColumnFilters?.rules.length);

    const handleClearFilters = () => {
        dispatch(setTableColumnFilters({filters: undefined}));
        window.dispatchEvent(new Event(TABLE_COLUMN_FILTER_CLEAR_EVENT_KEY));
    };

    return (
        <>
            {showClearButton && (
                <Badge
                    className="clear-table-column-filters-button-badge"
                    size="small"
                    count={tableColumnFilters?.groups.length}
                >
                    <Button
                        type="default"
                        onClick={handleClearFilters}
                    >
                        Очистить фильтры
                    </Button>
                </Badge>

            )}
        </>
    );
};
